import { QueryEntity } from "@datorama/akita";
import { singleton } from "tsyringe";

import ListingProductInfoStore, {
    ListingProductInfoState,
} from "../stores/ListingProductInfoStore";

@singleton()
class ListingProductInfoQuery extends QueryEntity<ListingProductInfoState> {
    constructor(protected listingProductInfoStore: ListingProductInfoStore) {
        super(listingProductInfoStore);
    }

    loading$ = this.selectLoading();
    error$ = this.selectError();
}

export default ListingProductInfoQuery;
